<div
  [ngClass]="{
    'flex-row-reverse': config?.widget?.legendPosition === 'right',
    'flex-column':
      config?.widget?.legendPosition === 'bottom' ||
      config?.widget?.legendPosition === 'top',
    'flex-column-reverse': config?.widget?.legendPosition === 'bottom',
  }"
  class="flex flex-1 justify-content-between align-items-stretch gap-0">
  @if (
    displayLegend &&
    type &&
    type !== 'adder' &&
    config &&
    config.widget.legendPosition !== 'none'
  ) {
    <app-chart-legend
      [ngClass]="{
        'max-w-12rem':
          config.widget.legendPosition === 'right' ||
          config.widget.legendPosition === 'left',
      }"
      class="align-self-center word-wrap"
      [type]="type"
      [widgetId]="config._id"
      [initialDisabledDatasets]="config.widget.disabledDatasets || []"
      [initialDisabledDataPoints]="config.widget.disabledDataPoints || []"
      [legendPosition]="config.widget.legendPosition || 'right'"
      [legendGroups]="chartData.legendGroups"
      [dataGroups]="chartData.groups"
      (datasetToggled)="onDatasetToggled($event)"
      (dataPointToggled)="onDataPointToggled($event)"
      [chartInstance]="chartInstance"
      [datasets]="chartData.datasets">
    </app-chart-legend>
  }

  <div class="flex-1 chart-wrapper" #chartComp>
    <canvas #chartCanvas></canvas>
  </div>
</div>
